var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"content"},[_c('b-row',[_c('b-col',[(_vm.storyId)?_c('StoryComponent',{attrs:{"index":0,"storyId":_vm.storyId,"startingStory":this.story,"displayLevel":3,"autoPlay":_vm.autoPlay}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }